import { render, staticRenderFns } from "./MealsTableView.vue?vue&type=template&id=f5cc98f6&scoped=true"
import script from "./MealsTableView.vue?vue&type=script&lang=js"
export * from "./MealsTableView.vue?vue&type=script&lang=js"
import style0 from "./MealsTableView.vue?vue&type=style&index=0&id=f5cc98f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5cc98f6",
  null
  
)

export default component.exports